import React from "react";
import { Form, Input } from "antd";
// import { UserInfoContext } from "Context/CommonContext";

export const POST_TYPES = [{ label: "Post", value: "POST" }];
export const GENERAL_SUBJECT = { label: "General", value: "general" };
const PostDetails = ({ form }: any) => {
  // const userInfo = useContext<any>(UserInfoContext);
  // const usersSubjects =
  //   userInfo?.subjectsListing?.map((subject: any) => ({
  //     label: subject.label,
  //     value: subject.label,
  //   })) || [];
  const description = Form.useWatch("description", form);
  const descriptionLength = description ? description.length : 0;
  // const subjectOptions = [GENERAL_SUBJECT, ...usersSubjects];
  return (
    <>
      <Form.Item
        name="title"
        label="Title"
        rules={[
          { required: true, message: "Please enter the title!", max: 500 },
        ]}
      >
        <Input maxLength={500} placeholder="Enter title..." />
      </Form.Item>
      <Form.Item
        name="description"
        label={`Content (${descriptionLength}/2000 characters)`}
        validateDebounce={1000}
        rules={[
          { max: 2000, message: "Limit exhausted" },
          { required: true, message: "Please enter the content!" },
        ]}
      >
        <Input.TextArea
          rows={4}
          placeholder="Write your message here..."
          maxLength={2000}
        />
      </Form.Item>
    </>
  );
};

export default PostDetails;
